import FirstStep from './first-step/first-step.vue';
import SecondStep from './second-step/second-step.vue';
import ThirdStep from './third-step/third-step.vue';
import FourStep from './four-step/four-step.vue';

export default [
  {
    path: 'first-step',
    name: 'registerFirstStep',
    component: FirstStep
  },
  {
    path: 'second-step',
    name: 'registerSecondStep',
    component: SecondStep
  },
  {
    path: 'third-step',
    name: 'registerThirdStep',
    component: ThirdStep
  },
  {
    path: 'four-step',
    name: 'registerFourStep',
    component: FourStep
  }
];
